import { useEffect, useState } from "react";

import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import { loadStripe } from "@stripe/stripe-js";
import { useContext } from 'react';
import { PriceContext } from './context';
import axios from 'axios';

function Payment() {
  const [stripePromise, setStripePromise] = useState(null);
  const [clientSecret, setClientSecret] = useState("");
  const { price, setPrice, setCredit, credit } = useContext(PriceContext);

  useEffect(() => {


  

     axios({
        method: 'post',
            url: `https://82jsvqje43.execute-api.us-east-2.amazonaws.com/wnba_dev/credits`,
       
        withCredentials: false,
        data: {
          path:'config'
        },
      }).then(function (response) {
        const publishableKey = response.data.publishableKey

         setStripePromise(loadStripe(publishableKey));
      })
      .catch(function (error) {
      });


      try {

     axios({
  method: 'post',
  url: `https://82jsvqje43.execute-api.us-east-2.amazonaws.com/wnba_dev/credits`,
  withCredentials: false,
  data: {
    path: 'create-payment-intent',
    amount: price
  },
})
.then(function(response) {
  console.log(response);
  let client_secret = response.data.clientSecret;
   // Corrected variable name
  setClientSecret(client_secret);
})
.catch(function(error) {
  console.error(error); // It's a good practice to log the error for debugging
});
      
      
      
      
      
       
      } catch (error) {
        
      }

  }, []);



  return (
    <>
      <h1>React Stripe and the Payment Element</h1>
      {clientSecret && stripePromise && (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <CheckoutForm />
        </Elements>
      )}
    </>
  );
}

export default Payment;
